import _typeof from "@babel/runtime/helpers/typeof";
import versionData from './versions';
// Version getter based on app's event data versions:
var versions = versionData;

var getEventTypeVersion = function getEventTypeVersion(eventName) {
  var nameAndVersion = versions.map.find(function (_ref) {
    var name = _ref.name;
    return eventName === name;
  });

  if (!nameAndVersion) {
    throw new Error("".concat(eventName, " is not a valid event name.  Please confirm you are using the correct chegg-event-spec package."));
  }

  return nameAndVersion.version;
}; // Guard against SSR scenario:
// tslint:disable-next-line: strict-type-predicates
// const win: Object = (typeof window === 'object' ? window : {}) as any;
// // This will be populated by handlebars.  Defaults to wtaCmd
// const globalCommandKey = 'globalRswCommand';
// // @ts-ignore
// win[globalCommandKey] = win[globalCommandKey] || []


var win = (typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object' ? window : {};
win.wtaCmd = win.wtaCmd || [];
export var rioEvent = function rioEvent(_ref2) {
  var data = _ref2.data,
      type = _ref2.type;
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var stateUpdate = config.stateUpdate,
      _config$force = config.force,
      force = _config$force === void 0 ? false : _config$force; // Obtain the version of the event being sent, in order to include it in the payload:

  var version = getEventTypeVersion(type); // Return a promise that resolves when the server has responded:

  return new Promise(function (resolve, reject) {
    // @ts-ignore
    win.wtaCmd.push(function (client) {
      if (stateUpdate) {
        client.updateState(stateUpdate);
      }

      var meta = {
        version: version,
        eventTime: new Date()
      };
      var eventSpecs = {
        type: type,
        data: data,
        meta: meta
      };
      var eventOpts = {
        force: force
      };

      client._nakedEvent(eventSpecs, eventOpts).then(resolve)["catch"](reject);
    });
  });
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-plat-ui/utils/dist/esm/rio/index.js
// module id = 5777
// module chunks = 11